
const PageLoader = () => (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
        <div className="text-center">
            <div
                className="animate-spin rounded-full h-10 w-10 sm:h-12 sm:w-12 border-b-2 mx-auto mb-3 sm:mb-4"
                style={{ borderColor: 'var(--color-primary-600)' }}
            ></div>
            <p className="text-sm sm:text-base" style={{ color: 'var(--color-text-secondary)' }}>
                Loading...
            </p>
        </div>
    </div>
);

export default PageLoader;